module.exports = " <spin _v-715a3e6c=\"\"> <icon type=load-c :size=size class=spin-icon-load _v-715a3e6c=\"\"></icon> </spin> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-715a3e6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 17
// module chunks = 1 2 3 4 5 6 7 8 9 10